import { useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { ButtonSubmit, Form } from '@anytag/shared-atoms';
import { CampaignInformation, Rates, Settings } from './formSections';
import { AutoManagedCampaignFormValues } from './types';

export const Template = () => {
  const { t } = useTranslation();
  const {
    formState: { isSubmitting }
  } = useFormContext<AutoManagedCampaignFormValues>();

  return (
    <>
      <Form.Body className="form-container">
        <CampaignInformation />
        <Form.Line className="my-6" />
        <Rates />
        <Form.Line className="my-6" />
        <Settings />
      </Form.Body>

      <Form.Footer>
        <ButtonSubmit type="submit" title={t('Button.Save')} loading={isSubmitting} />
      </Form.Footer>
    </>
  );
};
